/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { cn } from "@/lib/utils";
import { replaceImage } from "@/utils/basicFunctions.util";
import { useState } from "react";
import Image from "next/image";
const isUsableImageSrc = (value: string): boolean => {
  if (value.startsWith("/")) return true;
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};
const DEFAULT_PLACEHOLDER = "/icons/FYDO.png";

const CommonImage = ({
  src,
  alt,
  fallbackSrc,
  placeholderComponent,
  ...props
}: any) => {
  const [imageError, setImageError] = useState(false);

  const isMissing = imageError || !src;

  if (isMissing && placeholderComponent) {
    return placeholderComponent;
  }

  const safePlaceholder =
    fallbackSrc && isUsableImageSrc(fallbackSrc)
      ? fallbackSrc
      : DEFAULT_PLACEHOLDER;

  let resolvedSrc = safePlaceholder;
  if (!isMissing) {
    const candidateSrc = replaceImage(src) || safePlaceholder;
    resolvedSrc = isUsableImageSrc(candidateSrc)
      ? candidateSrc
      : safePlaceholder;
  }

  return (
    <Image
      {...props}
      src={resolvedSrc}
      onError={() => setImageError(true)}
      alt={alt || "image"}
      className={cn(props.className, imageError && "bg-black object-contain")}
    />
  );
};

export default CommonImage;
